// extracted by mini-css-extract-plugin
export var active = "_j2-2";
export var recordingDot = "_j2-1";
export var recordingIndicator = "_j2-0";